import React from 'react';
import * as Yup from 'yup';
import moment from "moment";
import language from '../languages';
import {firestore} from "../firebase";
import buildQuery from "./EntityUtil"

const meta = (lang) => { 
    return {
        entityName: language[lang].List,
        entityTitle: language[lang].Lists,
        emptyRow: () => {
            return {
                name: '',
                code: '',
                active: true,
                values: []
            }
        },
        collection: 'lookups',
        hideTitle: true,
        addButtonText: language[lang].New_List,
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        fields: [
            {name: 'name', default: null, dataType: 'string', label: 'Name', input: 'text'},
            {name: 'code', default: null, dataType: 'string', label: 'Code', input: 'text', disableValue: 'id',
                isDisabled: (value)=> {
                    if(value){
                        return true
                    }else{
                        return false
                    }
                }
            },
            {name: 'active', default: true, dataType: 'boolean', label: 'Activate', input: 'switch', color: 'primary'},
            {name: 'values', default:[], dataType: 'array', label: 'Lookup Values', input: 'arrayTable', 
                tableDef: [
                    {name: 'label', dataType: 'field', input: 'text', label: 'Label'},
                    {name: 'value', dataType: 'field', input: 'text', label: 'Value'},
                    {name: 'name', dataType: 'field', input: 'text', label: 'Display Order'},
                    ]}
            
        ],
        table: [
            {name: 'name', type: 'field', label: 'Name'},
            {name: 'code', type: 'field', label: 'Code'},
            {name: 'active', type: 'conditionField', label: 'Status', textForTrue: 'Active', textForFalse: 'Inactive'},
            {name: 'noOfItems', type: 'field', label: 'Value'},
            {name: 'lastUpdated', type: 'field', label: 'Last Updated'},
            {name: 'actions', type: 'action', label:'Actions', actions: ['delete', 'edit']}
        ],
        transform: (doc, id)=>{
            doc.noOfItems = doc.values ? doc.values.length : 0
            doc.lastUpdated = doc._updatedOn ? moment(doc._updatedOn).format('dddd, MMM DD') : moment(doc._createdOn).format('dddd, MMM DD')
            return doc;
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required(language[lang].Field_Required),
            code: Yup.string()
                .required(language[lang].Field_Required),
        }),
        filterObject: [],
        defaultOrderBy: ['name', 'desc'],
        searchableColumns: ['name','code'],
        getQuery: (paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) => {
            let query = {};
            query = firestore.collection('lookups');
            return buildQuery(query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage);
        },
        beforeSave: (user, doc)=> {
            return doc
        }
    }
}

export default meta;